import { useOktaAuth } from '@okta/okta-react';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

export const useEvents = () => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
    username,
    role,
  } = useSelector((state: any) => state.login.user);

  const path = `organizations/${currentOrg}/practices/${currentPractice}/${endpoints.events}`;
  return useMutation({
    mutationFn: async (trackEvent: any) => {
      await makeAPIRequestReactQuery(path, undefined, 'POST', {
        data: {
          name: trackEvent.eventName,
          body: { ...trackEvent.payload, username, userRole: role },
        },
      });
    },
  });
};

export const useGetEvents = (
  args?: { name?: string },
  options?: UseQueryOptions<TEvent, unknown, TEvent>,
) => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
  } = useSelector((state: any) => state.login.user);
  const { authState } = useOktaAuth();

  const isLoggedIn = authState?.isAuthenticated;
  const basePath = `organizations/${currentOrg}/practices/${currentPractice}/${endpoints.events}`;
  const path = args?.name ? `${basePath}/${args.name}` : basePath;

  return useQuery<TEvent>(
    [currentPractice, args?.name],
    () => makeAPIRequestReactQuery<TEvent>(path),
    { enabled: !!currentPractice && isLoggedIn, ...options },
  );
};

type TEvent = {
  createdAt: Date;
  body: Record<string, unknown>;
};
